module.exports = __webpack_public_path__ + "img/drug_card_layout__separate__fi.a6f3ab43.png";